import React from "react";
import robot from "@assets/gears_bot_2x.png";
import { Typography, Box, makeStyles, Link } from "@material-ui/core";

const getClassnames = makeStyles((theme) => ({
  robot: {
    backgroundImage: `url(${robot})`,
    backgroundPosition: "center",
    backgroundSize: "contain",
  },
}));

type Props = {
  error?: boolean;
  message?: string;
};

const SPLIT = /(?:\[(.*?)\))/g;
const LINK_PART = /^(.*?)(\]\(){1}(.*?)$/g;

export const Robot: React.FC<Props> = (props) => {
  const classnames = getClassnames();

  return props.message ? (
    <Box p={2} display="flex" flexDirection="column" alignItems="center">
      <Box px={2}>
        <Typography
          align="center"
          color={props.error ? "error" : "textPrimary"}
          variant="body2"
        >
          {props.message.split(SPLIT).map((part) => {
            if (part.match(LINK_PART)) {
              const [text, url] = part.split("](");

              return <Link href={url}>{text}</Link>;
            } else {
              return part;
            }
          })}
        </Typography>
      </Box>
      <Box width="2px" height="3rem" margin={2} bgcolor="primary.main" />
      <Box className={classnames.robot} width="126px" height="147px" />
    </Box>
  ) : null;
};
